/* eslint-disable consistent-return */
import { useEffect } from 'react';
import { useUploadContext } from '../contexts/UploadContext';
import uploadManager from '../utils/managers/uploadManager';

/**
 * 파일 업로드 관련 기능을 제공하는 커스텀 훅
 *
 * @param {Object} options - 훅 옵션
 * @param {string} options.userId - 사용자 ID
 * @param {string} options.userName - 사용자 이름
 * @returns {Object} 업로드 관련 메서드와 상태
 */
export default function useUpload({ userId, userName } = {}) {
  // 업로드 컨텍스트 가져오기
  const uploadContext = useUploadContext();

  // 사용자 정보 설정
  useEffect(() => {
    if (userId && userName) {
      uploadManager.setUserInfo(userId, userName);
    }
  }, [userId, userName]);

  // 업로드 중 페이지 이탈 경고
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (uploadManager.hasActiveUploads()) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return {
    // 컨텍스트에서 가져온 기능과 상태
    ...uploadContext,

    // 추가 편의 메서드
    showPanel: () => uploadContext.toggleVisibility(true),
    hidePanel: () => uploadContext.toggleVisibility(false),
  };
}
